import React from "react";
import {Route, Routes} from "react-router-dom";
import {AlertProvider} from "../context";
import {RoutesBackend} from "./backend2";
import {RoutesShop} from "./shop/RoutesShop";
import {ContactUs} from "./ContactUs";
import {RoutesCheckout} from "./checkout";
import {RoutesAccount} from "./account/RoutesAccount";
import {LandingPage} from "./LandingPage";
import {RoutesGit} from "../markdown/RoutesGit";
import {RoutesDevice} from "./device/RoutesDevice";

export function MainBootstrap() {

    return <AlertProvider>
        <main>
            <Routes>
                <Route index element={<LandingPage/>}/>

                <Route path="/account/*" element={<RoutesAccount/>}/>

                <Route path="/backend/*" element={<RoutesBackend/>}/>

                <Route path="/device/:uid/*" element={<RoutesDevice/>}/>

                <Route path="/shop/*" element={<RoutesShop/>}/>

                <Route path="/checkout/*" element={<RoutesCheckout/>}/>

                <Route path="/git" element={<RoutesGit/>}/>
                <Route path="/git/:base/*" element={<RoutesGit/>}/>

                <Route path="/contact-us" element={<ContactUs/>}/>

                <Route path="*" element={<NotFound/>}/>
            </Routes>
        </main>
    </AlertProvider>
}

function NotFound() {
    return <h1>404 Page not found</h1>
}
